import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
	declarations: [],
	exports: [TranslateModule],
	imports: [
		CommonModule,
		TranslateModule.forRoot({
			// defaultLanguage: 'en',
			// commented out to avoid "flash" of English text before Danish/browser language text.
			// Set in AppComponent constructor instead
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class NgxTranslateModule {}
